import { render, staticRenderFns } from "./EntityCalendarWidgets.vue?vue&type=template&id=008d31e7&scoped=true"
import script from "./EntityCalendarWidgets.vue?vue&type=script&lang=js"
export * from "./EntityCalendarWidgets.vue?vue&type=script&lang=js"
import style0 from "./EntityCalendarWidgets.vue?vue&type=style&index=0&id=008d31e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d31e7",
  null
  
)

export default component.exports